'use client'

import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cn } from '~/lib/utils'

type StatusKind = 'objective' | 'time'
type StatusState = 'notStarted' | 'inProgress' | 'complete'

function getState({ completed, total }: { completed: number; total: number }): StatusState {
  if (total > 0 && completed >= total) {
    return 'complete'
  }

  if (completed > 0) {
    return 'inProgress'
  }

  return 'notStarted'
}

export default function OverviewStatusChip({
  icon,
  label,
  completed,
  total,
  kind,
  showWhenZero = false,
}: {
  icon: IconDefinition
  label: string
  completed: number
  total: number
  kind: StatusKind
  showWhenZero?: boolean
}) {
  if (!showWhenZero && total === 0) {
    return null
  }

  const state = getState({ completed, total })
  const classesByState: Record<StatusState, string> = {
    complete: 'text-uzh-darkgreen',
    inProgress: 'text-primary-100',
    notStarted: 'text-gray-500',
  }
  const isTime = kind === 'time'

  return (
    <div
      className={cn(
        'flex w-full items-center gap-0.5 whitespace-nowrap text-xs font-medium tabular-nums sm:text-sm',
        classesByState[state],
      )}
      data-kind={kind}
      data-state={state}
    >
      <FontAwesomeIcon icon={icon} className="h-3 w-3 sm:h-3.5 sm:w-3.5" />
      <span className={cn('min-w-0', isTime && 'ml-auto text-right')}>{label}</span>
    </div>
  )
}
